import Head from 'next/head';
import Header from '@/components/Header';
import { Box, ContentBox, TitleBox } from '@/styles/styled';
import OTP from '@/components/OTP';
import { useAppSelector } from '@/redux/hooks';
import { useEffect, useState } from 'react';
import { getSessionStorage, setSessionStorage } from '@/utils';
import useWindowSize from '@/hooks/useWindowSize';
import { useRouter } from 'next/router';
import { CheckAuth, CreateSession } from '@/services/session-service';
import Loader from '@/components/Loader';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { reportHomePageView } from '@/utils/reporter';
import { isBrowser } from '@/utils/general';
import BlockBanner from '@/components/BlockBanner/BlockBanner';
import { resetStore } from '@/redux/appSlice';
import React from 'react';
import AdvantageOfVf from '@/components/AdvantageOfVf/AdvantageOfVf';

export default function Home() {
  const { sid, phone } = useAppSelector((state) => state.app);
  const router = useRouter();
  const size: { width: number | undefined; height: number | undefined } =
    useWindowSize();
  const [storedData, setStoredData] = useState<any>({});
  const [autoLogin, setAutoLogin] = useState<any>();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const [linkat, setLinkat] = useState<boolean>(false);

  useEffect(() => {
    if (
      router.query.couponCode ||
      router.query.couponCode == '' ||
      getSessionStorage('couponCode')
    ) {
      setLinkat(true);
    }
  }, [router]);

  useEffect(() => {
    dispatch(resetStore());
  }, []);

  useEffect(() => {
    if (isBrowser() && window.clientVariables.sid) {
      window.location.href = `${process.env.NEXT_PUBLIC_BASE_PATH}/home/address?channel=app`;
    }
  }, []);

  useEffect(() => {
    setSessionStorage('couponCode', router.query.couponCode || null);
    if (router?.query?.tbg) {
      setSessionStorage('tbg', router.query.tbg);
    }
    if (router?.query?.tracking_cid) {
      setSessionStorage(
        'tracking_cid_congestion',
        router?.query?.tracking_cid?.includes('congestion')
      );

      setSessionStorage('trackingCid', router.query.tracking_cid);
    }
    if (router?.query?.couponCode?.includes('FIBER')) {
      setSessionStorage('journey_subtype', 'link');
    }
    if (router?.query?.couponCode == '' || router?.query?.couponCode == ' ') {
      setSessionStorage('journey_subtype', 'couponCode');
    }
    setSessionStorage('referer', router?.query?.referer || null);
  }, [router]);

  useEffect(() => {
    sessionStorage.removeItem('upsellPopupOpen');
    sessionStorage.removeItem('upsellAction');
    sessionStorage.removeItem('tariffGroup');
    sessionStorage.removeItem('tbg');
  }, []);

  useEffect(() => {
    setSessionStorage('userData', storedData);
  }, [storedData]);

  useEffect(() => {
    if (
      router &&
      router.query &&
      router.query.tags &&
      router.query.tags?.length > 0
    ) {
      setStoredData((prevState: any) => ({
        ...prevState,
        tags: router.query.tags,
      }));
    }

    if (
      router.query &&
      router.query.referer &&
      router.query.referer?.length > 0
    ) {
      setStoredData((prevState: any) => ({
        ...prevState,
        referer: router.query.referer,
      }));
    }

    if (
      router.query &&
      router.query.referrer &&
      router.query.referrer?.length > 0
    ) {
      setStoredData((prevState: any) => ({
        ...prevState,
        referer: router.query.referrer,
      }));
    }
  }, [router]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await dispatch(CheckAuth());
        setAutoLogin(res.payload.success);
        if (res.payload.success == true) {
          dispatch(CreateSession())
            .then((sessionRes) => {
              if (sessionRes?.payload?.result?.result == 'FAIL') {
                setAutoLogin(false);
                reportHomePageView();
              } else if (sessionRes?.payload?.result?.result == 'SUCCESS') {
                setSessionStorage('autoLogin', true);
                reportHomePageView('true');
              }
              return;
            })
            .catch((error) => {
              reportHomePageView();
              setAutoLogin(false);
              console.log(error);
            });
        }
        if (res?.payload?.success == false) {
          reportHomePageView();
          setAutoLogin(false);
        }
      } catch (error) {
        reportHomePageView();
        console.log(error);
        setAutoLogin(false);
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <>
      <Head>
        <title>Vodafone Ev İnterneti</title>
        <meta name="description" content="Vodafone Ev İnterneti" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta key="robots" name="robots" content="noindex" />
        <meta key="googlebot" name="googlebot" content="noindex" />
      </Head>
      <Header />
      <ContentBox>
        <BlockBanner
          backgroundImage="https://cms.vodafone.com.tr/static/img/content/24-09/19/gsm-page-banner-1.svg"
          mobileBackgroundImage="https://cms.vodafone.com.tr/static/img/content/24-12/09/m-ic-sayfalar-1.svg"
          text1="Yenilenen Vodafone Ev İnterneti "
          text2="ile Evleri Yeniliyoruz!"
        />
        {
          <Box>
            {autoLogin && !phone ? (
              <Loader />
            ) : (
              <>
                <TitleBox sid={sid}>
                  <OTP
                    AutoLogin={autoLogin}
                    setAutoLogin={setAutoLogin}
                    isLinkat={linkat}
                  />
                  <AdvantageOfVf />
                </TitleBox>
              </>
            )}
          </Box>
        }
      </ContentBox>
    </>
  );
}
